var map = {
	"./alphabet.png": 566,
	"./alphabet_responsive.png": 567,
	"./balloons.png": 568,
	"./balloons_responsive.png": 569,
	"./buffet.png": 570,
	"./buffet_responsive.png": 571,
	"./circle_horizontal.png": 572,
	"./circle_horizontal_responsive.png": 573,
	"./circle_vertical.png": 574,
	"./circle_vertical_responsive.png": 575,
	"./cleaning_horizontal.png": 576,
	"./cleaning_horizontal_responsive.png": 577,
	"./cleaning_vertical.png": 578,
	"./cleaning_vertical_responsive.png": 579,
	"./constellations.png": 580,
	"./constellations_responsive.png": 581,
	"./ducks.png": 582,
	"./ducks_responsive.png": 583,
	"./hockey.png": 584,
	"./hockey_responsive.png": 585,
	"./quality_control.png": 586,
	"./quality_control_responsive.png": 587,
	"./shelves.png": 588,
	"./shelves_responsive.png": 589,
	"./spheroids.png": 590,
	"./spheroids_responsive.png": 591,
	"./training.png": 592,
	"./training_responsive.png": 593,
	"./tubes.png": 594,
	"./tubes_responsive.png": 595,
	"./whac_a_mole.png": 596,
	"./whac_a_mole_responsive.png": 597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;